/**
 * iOS / 旧版 WebKit：部分环境下仅有 navigator.webkitGetUserMedia，尚无 navigator.mediaDevices。
 * 若不垫片，MicrophoneModule 会在 requestPermission 时误判为「不支持」并抛错；Android Chromium 通常自带 mediaDevices。
 * 须在任意 getUserMedia 调用之前执行（建议在 index.tsx 最先 import）。
 */
export function applyMediaDevicesPolyfill(): void {
  if (typeof navigator === 'undefined') {
    return;
  }

  if (!navigator.mediaDevices) {
    (navigator as unknown as { mediaDevices: Partial<MediaDevices> }).mediaDevices = {};
  }

  const md = navigator.mediaDevices as MediaDevices & {
    getUserMedia?: (c: MediaStreamConstraints) => Promise<MediaStream>;
  };

  if (typeof md.getUserMedia === 'function') {
    return;
  }

  const legacy = (
    (navigator as unknown as { webkitGetUserMedia?: LegacyGUM }).webkitGetUserMedia ||
    (navigator as unknown as { mozGetUserMedia?: LegacyGUM }).mozGetUserMedia ||
    (navigator as unknown as { getUserMedia?: LegacyGUM }).getUserMedia
  )?.bind(navigator);

  if (!legacy) {
    return;
  }

  md.getUserMedia = function (constraints: MediaStreamConstraints) {
    return new Promise<MediaStream>((resolve, reject) => {
      legacy(constraints, resolve, reject);
    });
  };
}

type LegacyGUM = (
  constraints: MediaStreamConstraints,
  success: (s: MediaStream) => void,
  error: (e: Error) => void
) => void;
